import { PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_ENTRA_CLIENT_ID;
const authority = process.env.REACT_APP_ENTRA_AUTHORITY || 'https://login.microsoftonline.com/common';
const redirectUri = process.env.REACT_APP_ENTRA_REDIRECT_URI || `${window.location.origin}/sso`;
const scopes = (process.env.REACT_APP_ENTRA_SCOPES || 'openid profile email').split(' ').filter(Boolean);

export const msalConfig = {
  auth: {
    clientId: clientId || '',
    authority,
    redirectUri,
    ...(authority.includes('b2clogin.com') && {
      knownAuthorities: [new URL(authority).hostname]
    })
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
};

let msalInstancePromise = null;

export const getMsalInstance = async () => {
  if (!msalInstancePromise) {
    const pca = new PublicClientApplication(msalConfig);
    msalInstancePromise = pca.initialize().then(() => pca);
  }
  return msalInstancePromise;
};

export { scopes };

/**
 * Logs out from Microsoft Entra ID SSO if the user has an active SSO session.
 * Redirects to Microsoft's logout endpoint, then back to the login page.
 * Returns true if SSO logout was initiated (redirect will happen), false otherwise.
 * Note: Ensure {origin}/login is registered as a Redirect URI in your Azure app registration.
 */
export const logoutFromSSO = async () => {
  if (!clientId) return false;

  try {
    const msalInstance = await getMsalInstance();
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length > 0) {
      const postLogoutRedirectUri = `${window.location.origin}/login`;
      await msalInstance.logoutRedirect({
        postLogoutRedirectUri,
        account: accounts[0]
      });
      return true;
    }
  } catch (err) {
    console.error('SSO logout failed:', err);
  }
  return false;
};
